module.exports = __webpack_public_path__ + "img/redness_1.f3365af7.png";